function fly(img){
    var cart = $('.cart-preview');
    if (img) {
        var startTop = img.closest("[data-product='holder']").offset().top,
            startLeft = img.closest("[data-product='holder']").offset().left;
        var imgclone = img.clone()
            .offset({top: startTop, left: startLeft})
            .css({'opacity': '0.7', 'position': 'absolute', 'height': '120px', 'width': '120px', 'margin-left': '0', 'z-index': '999999'})
            .appendTo($('body'))
            .animate({
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 30,
                'width': 60,
                'height': 60
            }, 1000, 'easeInElastic');
        imgclone.animate({'width': 0, 'height': 0}, function () {
            $(this).detach();
        });
    }
}

function validateEmail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

$(".autocomplete-input").autocomplete({
    minLength: 3,
    source: function(keyword, callback) {
        $.ajax({
            url: SITE_URL + "products/autocomplete/" + $(this.element).data("lang"),
            dataType: "json",
            type: "POST",
            data: keyword,
            success: function(data) {
                if (data.no_data) {
                    var message = [{label: data.message}];
                    callback(message);
                }
                else {
                    //callback(response.products);
                    callback($.map(data.products, function(el, index) {
                        return {
                            value: el.label,
                            avatar: el.img,
                            url: el.url,
                            price: el.price,
                            show_all: el.show_all
                        };
                    }));
                }
            }
        });
    }
}).data("ui-autocomplete")._renderItem = function (ul, item) {
    if (item.url) {
        if (item.show_all == 'show_all') {
            return $("<li />")
            .data("item.autocomplete", item)
            .append("<a href='" + item.url + "' class="+ item.show_all +"><span class='ui-block'><span class='product-title'> " + item.value + " </span></span></a>")
            .appendTo(ul);
        }
        else {
            return $("<li />")
            .data("item.autocomplete", item)
            .append("<a href='" + item.url + "'><img src='" + item.avatar + "' /> <span class='ui-block'><span class='product-title'> " + item.value + ' </span><span class="product-price"> ' + item.price +"</span></span></a>")
            .appendTo(ul);
        }

    }
    else {
        return $("<li />")
        .data("item.autocomplete", item)
        .append(item.value)
        .appendTo(ul);
    }

};

$(".autocomplete-input").on("autocompleteselect", function(event, ui) {
    if (typeof ui.item.url != "undefined") {
        window.location.replace(ui.item.url);
    }
});

// add to cart action
$("body").on("click", "a.add-to-cart", function (e) {
    e.preventDefault();

    var product_id = $(this).attr("data-id"),
        lang = $(this).data("lang"),
        trigger = $(this).data("trigger"),
        amount = 1;

    switch (trigger) {
        case "list":
            break;
        case "quick-view":
            amount = $("#amount-quick").val().trim();
            break;
        case "product-page":
            amount = $("#amount-product-page").val().trim();
            break;
        default:
            break;
    }

    var imgtofly = $(this).closest("[data-product='holder']").find("[data-product='img']").eq(0);

    $.ajax({
        type: "post",
        url: SITE_URL + "cart/ajax_add_product",
        data: {
            product_id: product_id,
            lang: lang,
            amount: amount
        },
        dataType: "json",
        success: function (data) {
            if (data.success) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                'event': 'addToCart'
                });
                $("#shop-cart").replaceWith(data.cart);

                if (typeof imgtofly.offset() === "undefined") {
                    modal.open();
                    $modalMessage.html("<p>Proizvod je dodat u korpu</p>");
                } else {
                    fly(imgtofly);
                }
            } else {
                modal.open();
                $modalMessage.html("<p>"+ data.message +"</p>");
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
});

$("body").on("click", ".expand", function (e) {
    e.preventDefault();

    var id = $(this).data("id"),
        lang = $(this).data("lang");

    $('#product_quick_view_div').load(
        SITE_URL + "products/product_quick_view/" + lang + "/" + id,
        function () {
            $(this).fadeIn();
        });
});

$("body").on("click", ".expand-voucher", function (e) {
    e.preventDefault();

    var id = $(this).data("id"),
        lang = $(this).data("lang");

    $('#product_quick_view_div').load(
        SITE_URL + "pages/voucher_quick_view/" + lang + "/" + id,
        function () {
            $(this).fadeIn();
        });
});

$("body").on("click", ".expand-forward", function (e) {
    e.preventDefault();

    var id = $(this).data("id"),
        lang = $(this).data("lang");

    $('#forward_voucher_div').load(
        SITE_URL + "users/forward_voucher/" + lang + "/" + id,
        function () {
            $(this).fadeIn();
        });
});

// code for remodal
var $modalMessage = $('.modal-text'),                   //text inside modal
    modal = $('[data-remodal-id=modal]').remodal({
        hashTracking: false
    });

$(document).on('closed', '.remodal', function () {      //on modal close remove custom classes, text and data attributes (remodal-name)
    $('.modal-text').html('');
    $('.remodal').removeClass('two-options').attr( 'data-remodal-name', '' );
});

// remove from cart action
$("body").on("click", ".remove-item", function(e) {
    e.preventDefault();

    modal.open();
    $('.remodal').addClass('two-options');
    $(".remodal").attr( "data-remodal-name", "removeItem" );

    var url = $(this).data("url"),
        message = $(this).data("message"),
        chart_id = $(this).data("chart-id"),
        lang = $(this).data("lang");

    $modalMessage.html("<p>"+ message +"</p>");

    $(document).on('confirmation', '.remodal', function () {
        if($(".remodal").attr( 'data-remodal-name' ) == 'removeItem'){
            $.ajax({
                type: "post",
                url: SITE_URL + "products/get_product_data_for_analytics_session_id/" + lang + "/" + chart_id,
                dataType: "json",
                async: false,
                success: function (data) {
                    var product_price = data.product.sale == 1 ? data.amount * data.product.promotion_price : data.amount * data.product.main_price;
                    window.dataLayer.push({
                        'event': 'removeFromCart',
                        'ecommerce': {
                            'currencyCode': data.currency_code,
                            'remove': {
                                'products': [{
                                    'name': data.product.name,
                                    'id': data.product.id,
                                    'price': data.product.sale == 1 ? data.product.promotion_price : data.product.main_price,
                                    'brand': data.product.brand_name ? data.product.brand_name : 'undefined',
                                    'category': data.category.category_name,
                                    'quantity': data.amount,
                                    'dimension3': data.total_price - product_price,
                                    'metric1':  parseInt('-' + product_price)
                                }]
                            }
                        }
                    });
                },
                error: function () {
                    console.log('Error');
                }
            });

            window.location.href = url;
        }
    });
});

$('[data-remodal-id=modal-send-friend]').remodal({
    hashTracking: false
});


// add to wishlist action
$("body").on("click", ".add-to-wishlist", function (e) {
    e.preventDefault();

    var product_id = $(this).data("id");

    $.ajax({
        url: SITE_URL + "products/ajax_add_to_wishlist",
        type: "post",
        data: {
            product_id: product_id,
            lang: LANG
        },
        success: function (data) {
            modal.open();
            $modalMessage.html("<p>"+ data +"</p>");
        },
        error: function () {
            modal.open();
            $modalMessage.html("<p>FATAL! Server error!</p>");
        }
    });
});

// user login form action
$(".user-login-form").submit(function (e) {
    e.preventDefault();

    var email = $(this).find("input[name=email]"),
        password = $(this).find("input[name=password]"),
        notification = $(this).find(".notification");

    if (email.val() == "") {
        notification.html("<span>" + email.data("message-required") + "</span>");
        return false;
    } else {
        if (!validateEmail(email.val())) {
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            return false;
        }
    }

    if (password.val() == "") {
        notification.html("<span>" + password.data("message-required") + "</span>");
        return false;
    }

    $.ajax({
        url: SITE_URL + "users/ajax_login",
        type: "post",
        data: {
            email: email.val(),
            password: password.val()
        },
        dataType: "json",
        success: function(data) {
            if (data.success) {
                window.location.replace(data.redirect_url)
            } else {
                notification.html("<span>" + data.message + "</span>");
            }
        }
    });
});

// reset password form action
$(".reset-password-form").submit(function (e) {
    e.preventDefault();

    var email = $(this).find("input[name=email]"),
        notification = $(this).find(".notification");

    if (email.val().trim() == "") {
        notification.html("<span>" + email.data("message-required") + "</span>");
        return false;
    } else {
        if (!validateEmail(email.val().trim())) {
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            return false;
        }
    }
    $.ajax({
        url: SITE_URL + "users/request_password_reset",
        type: "post",
        data: {
            email: email.val(),
            lang: LANG
        },
        dataType: "json",
        success: function (data) {
            if (data.success) {
                email.val("");
            }
            notification.html("<span>" + data.message + "</span>");
        },
        error: function () {
            modal.open();
            $modalMessage.html("<span>FATAL! Server error!</span>");
        }
    });
});

// checkbox toggler action
$(".checkbox-toggler").click(function() {
    if ($(this).is(":checked")) {
        $(this).parent().find("input:hidden").val("1");
    } else {
        $(this).parent().find("input:hidden").val("0");
    }
});

$('#user-account-form').submit(function (e){
    var companyName = $(this).find("input[name=company_name]"),
    companyPib = $(this).find("input[name=company_pib]"),
    companyRegNumber = $(this).find("input[name=company_reg_number]"),
    firstName = $(this).find("input[name=first_name]"),
        lastName = $(this).find("input[name=last_name]"),
        //birthDate = $(this).find("input[name=birth_date]"),
        email = $(this).find("input[name=email]"),
        phone = $(this).find("input[name=phone]"),
        city = $(this).find("input[name=city]"),
        street = $(this).find("input[name=street]"),
        //streetNumber = $(this).find("input[name=street_number]"),
        postalCode = $(this).find("input[name=postal_number]"),
        area_code = $(this).find("input[name=area_code]"),
        notification = $(this).find(".notification"),
        terms = $(this).find($("#terms-and-conditions"));

    // check company related data if needed
    if ($("#company").val() == 1) {
        if (companyName.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyName.data("message-required") + "</span>");
            return false;
        }

        if (companyPib.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyPib.data("message-required") + "</span>");
            return false;
        }

        if (companyRegNumber.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyRegNumber.data("message-required") + "</span>");
            return false;
        }
    }

    if (firstName.val() == "") {
        e.preventDefault();
        notification.html("<span>" + firstName.data("message-required") + "</span>");
        return false;
    }

    if (lastName.val() == "") {
        e.preventDefault();
        notification.html("<span>" + lastName.data("message-required") + "</span>");
        return false;
    }

    /*if (birthDate.val() == "") {
        e.preventDefault();
        notification.html("<span>" + birthDate.data("message-required") + "</span>");
        return false;
    }*/

    if (email.val() == "") {
        e.preventDefault();
        notification.html("<span>" + email.data("message-required") + "</span>");
        return false;
    } else {
        if (!validateEmail(email.val())) {
            e.preventDefault();
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            return false;
        }
    }

    if (area_code.val() == "") {
        e.preventDefault();
        notification.html("<span>" + area_code.data("message-required") + "</span>");
        return false;
    }

    if (phone.val() == "") {
        e.preventDefault();
        notification.html("<span>" + phone.data("message-required") + "</span>");
        return false;
    }

    if (city.val() == "") {
        e.preventDefault();
        notification.html("<span>" + city.data("message-required") + "</span>");
        return false;
    }

    if (street.val() == "") {
        e.preventDefault();
        notification.html("<span>" + street.data("message-required") + "</span>");
        return false;
    }

    // if (streetNumber.val() == "") {
    //     e.preventDefault();
    //     notification.html("<span>" + streetNumber.data("message-required") + "</span>");
    //     return false;
    // }

    if (postalCode.val() == "") {
        e.preventDefault();
        notification.html("<span>" + postalCode.data("message-required") + "</span>");
        return false;
    }

    if (!terms.is(":checked")) {
        e.preventDefault();
        notification.html("<span>" + terms.data("message-required") + "</span>");
        return false;
    }

    $('.register_page_button').hide();
    $('.register_page_loading').show();
});

// registration form validation
$(".user-register-form").submit(function (e) {
    var  companyName = $(this).find("input[name=company_name]"),
    companyPib = $(this).find("input[name=company_pib]"),
    companyRegNumber = $(this).find("input[name=company_reg_number]"),
    firstName = $(this).find("input[name=first_name]"),
        lastName = $(this).find("input[name=last_name]"),
        //birthDate = $(this).find("input[name=birth_date]"),
        email = $(this).find("input[name=email]"),
        phone = $(this).find("input[name=phone]"),
        city = $(this).find("input[name=city]"),
        street = $(this).find("input[name=street]"),
        //streetNumber = $(this).find("input[name=street_number]"),
        postalCode = $(this).find("input[name=postal_number]"),
        password = $(this).find("input[name=password]"),
        repeatPassword = $(this).find("input#repeat-password"),
        area_code = $(this).find("input[name=area_code]"),
        notification = $(this).find(".notification"),
        terms = $(this).find($("#terms-and-conditions")),
        fakeUserType = $(this).find("input[name=fake_user_type]");


    // check company related data if needed
    if ($("#legal_entity").is(":checked")) {
        if (companyName.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyName.data("message-required") + "</span>");
            errors.push('error');
            return false;
        }

        if (companyPib.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyPib.data("message-required") + "</span>");
            errors.push('error');
            return false;
        }

        if (companyRegNumber.val() == "") {
            e.preventDefault();
            notification.html("<span>" + companyRegNumber.data("message-required") + "</span>");
            errors.push('error');
            return false;
        }
    }
    if ($(this).hasClass('affiliate-form')) {
        
        var username = $(this).find("input[name=username]"),
            links = $(this).find("input[name=affiliate_links]");

        if (username.val().trim() == "") {
            e.preventDefault();
            notification.html("<span>" + username.data("message-required") + "</span>");
            return false;
        }

        if (username.val().length > 10) {
            e.preventDefault();
            notification.html("<span>" + username.data("message-limit") + "</span>");
            return false;
        }
    
        if (links.val().trim() == "") {
            e.preventDefault();
            notification.html("<span>" + links.data("message-required") + "</span>");
            return false;
        }
    }    


    if (firstName.val() == "") {
        e.preventDefault();
        notification.html("<span>" + firstName.data("message-required") + "</span>");
        return false;
    }

    if (lastName.val() == "") {
        e.preventDefault();
        notification.html("<span>" + lastName.data("message-required") + "</span>");
        return false;
    }

    /*if (birthDate.val() == "") {
        e.preventDefault();
        notification.html("<span>" + birthDate.data("message-required") + "</span>");
        return false;
    }*/

    if (email.val() == "") {
        e.preventDefault();
        notification.html("<span>" + email.data("message-required") + "</span>");
        return false;
    } else {
        if (!validateEmail(email.val())) {
            e.preventDefault();
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            return false;
        }
    }

    if (area_code.val() == "") {
        e.preventDefault();
        notification.html("<span>" + area_code.data("message-required") + "</span>");
        return false;
    }

    if (phone.val() == "") {
        e.preventDefault();
        notification.html("<span>" + phone.data("message-required") + "</span>");
        return false;
    }

    if (city.val() == "") {
        e.preventDefault();
        notification.html("<span>" + city.data("message-required") + "</span>");
        return false;
    }

    if (street.val() == "") {
        e.preventDefault();
        notification.html("<span>" + street.data("message-required") + "</span>");
        return false;
    }

    // if (streetNumber.val() == "") {
    //     e.preventDefault();
    //     notification.html("<span>" + streetNumber.data("message-required") + "</span>");
    //     return false;
    // }

    if (postalCode.val() == "") {
        e.preventDefault();
        notification.html("<span>" + postalCode.data("message-required") + "</span>");
        return false;
    }

    if (password.length) {
        if (password.val() == "") {
            e.preventDefault();
            notification.html("<span>" + password.data("message-required") + "</span>");
            return false;
        }

        if (repeatPassword.val() == "") {
            e.preventDefault();
            notification.html("<span>" + repeatPassword.data("message-required") + "</span>");
            return false;
        } else {
            if (repeatPassword.val() != password.val()) {
                e.preventDefault();
                notification.html("<span>" + repeatPassword.data("message-incorrect") + "</span>");
                return false;
            }
        }
    }

    if (!terms.is(":checked")) {
        e.preventDefault();
        notification.html("<span>" + terms.data("message-required") + "</span>");
        return false;
    }

    // if ($("#recaptcha-holder").length) {
    //     var captcha = grecaptcha.getResponse(captchaWidget);

    //     if (captcha.length == 0) {
    //         e.preventDefault();
    //         notification.html("<span>" + $("#recaptcha-holder").data("message-required") + "</span>");
    //         return false;
    //     }
    // }

    // if ($(this).find("input[name=g-recaptcha-response]").length) {
    //     $(this).find("input[name=g-recaptcha-response]").attr("disabled", true);
    // }

    if (fakeUserType.length > 0) {
        fakeUserType.attr("disabled", true);
    }

    $('.register_page_button').hide();
    $('.register_page_loading').show();
});

$("button.go-back").click(function () {
    window.history.back();
});

$("a.go-back").click(function (e) {
    e.preventDefault();

    window.history.back();
});

$(".update-amount-trigger").click(function (e) {
    e.preventDefault();

    $(this).parent().parent().trigger("submit");
});

$("#update-amount-form").submit(function (e) {
    var amount = $(this).find("input[name=amount]");

    if (!parseInt(amount.val()) > 0) {
        e.preventDefault();
        modal.open();
        $modalMessage.html("<p>"+ amount.data("message-incorrect") +"</p>");
    }
});

// contact form validation and sending
$("#contact-form").submit(function (e) {
    e.preventDefault();

    var firstName = $(this).find("input[name=first_name]"),
        //lastName = $(this).find("input[name=last_name]"),
        email = $(this).find("input[name=email]"),
        message = $(this).find("textarea[name=message]"),
        recaptchaHolder = $(this).find("#recaptcha-holder"),
        notification = $(this).find(".notification");

    if (firstName.val() == "") {
        notification.html("<span>" + firstName.data("message-required") + "</span>");
        return false;
    }

    //if (lastName.val() == "") {
    //    notification.html("<span>" + lastName.data("message-required") + "</span>");
    //    return false;
    //}

    if (email.val() == "") {
        notification.html("<span>" + email.data("message-required") + "</span>");
        return false;
    } else {
        if (!validateEmail(email.val())) {
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            return false;
        }
    }

    if (message.val() == "") {
        notification.html("<span>" + message.data("message-required") + "</span>");
        return false;
    }

    var captcha = grecaptcha.getResponse(captchaWidget);

    if (captcha.length == 0) {
        notification.html("<span>" + recaptchaHolder.data("message-required") + "</span>");
        return false;
    }

    $.ajax({
        url: SITE_URL + "pages/send_email/" + LANG,
        type: "post",
        data: {
            first_name: firstName.val(),
            //last_name: lastName.val(),
            email: email.val(),
            message: message.val()
        },
        dataType: "json",
        success: function (data) {
            notification.html("<span>" + data.message + "</span>");
        },
        error: function () {
            modal.open();
            $modalMessage.html("<p>FATAL! Server error!</p>");
        }
    });
});

//
$("#delivery-form").submit(function (e) {
    var indicator = $(this).find("input[name=new_address_indicator]"),
        newName = $(this).find("input[name=new_name]"),
        contactPhone = $(this).find("input[name=new_phone]"),
        newAddress = $(this).find("input[name=new_address]"),
        newPostalCode = $(this).find("input[name=new_po_number]"),
        newCity = $(this).find("input[name=new_city]"),
        area_code = $(this).find("input[name=new_area_code]"),
        paymentType = $(this).find("input[name=payment_type]"),
        paymentTypeChecked = $(this).find("input[name=payment_type]:checked"),
        terms = $(this).find("input#terms-and-conditions"),
        termsChecked = $(this).find("input#terms-and-conditions:checked"),
        notification = $(this).find(".notification"),
        serbiaOnly = $(".serbia_only").data('value'),
        country_id = $(".serbia_only").data('country'),
        eu_terms = $(this).find("input#eu-terms"),
        eu_termsChecked = $(this).find("input#eu-terms:checked"),
        delivery_type = $(this).find("input[name=delivery_type]"),
        delivery_typeChecked = $(this).find("input[name=delivery_type]:checked"),
        new_country = $("#new-country").val(),
        loaderHolder = $(this).find('.loader-holder'),
        triggerBtn = $(this).find('.cofirm_order');

        var eu_countries = ["16", "23", "35", "59", "62", "63", "64", "74", "80", "81", "88", "91", "104", "110", "113", "125", "131", "132", "140", "159", "180",
        "181", "185", "198", "199", "206", "219"];

        notification.empty();

    if ((indicator.val() == "0" && serbiaOnly == 1 && country_id != 193) || (indicator.val() == "1" && serbiaOnly == 1 && new_country != 193)) {
        e.preventDefault();
        notification.html("<span>" + $(".serbia_only").data("serbia-only") + "</span>");
        return false;
    }
    if (delivery_typeChecked.length == 0) {
        e.preventDefault();
        notification.html("<span>" + delivery_type.data("message-required") + "</span>");
        return false;
    }

    if (paymentTypeChecked.length == 0) {
        e.preventDefault();
        notification.html("<span>" + paymentType.data("message-required") + "</span>");
        return false;
    }

    if (indicator.val() == "0" && eu_countries.includes(country_id.toString()) || (indicator.val() == "1" && eu_countries.includes(new_country.toString()))) {
        if (eu_termsChecked.length == 0) {
            e.preventDefault();
            notification.html("<span>" + eu_terms.data("message-required") + "</span>");
            return false;
        }
    }

    if (termsChecked.length == 0) {
        e.preventDefault();
        notification.html("<span>" + terms.data("message-required") + "</span>");
        return false;
    }

    if (indicator.val() == "1") {
        if (newName.val() == "") {
            e.preventDefault();
            notification.html("<span>" + newName.data("message-required") + "</span>");
            return false;
        }

        if (contactPhone.val() == "") {
            e.preventDefault();
            notification.html("<span>" + contactPhone.data("message-required") + "</span>");
            return false;
        }

        if (newAddress.val() == "") {
            e.preventDefault();
            notification.html("<span>" + newAddress.data("message-required") + "</span>");
            return false;
        }
        if (newPostalCode.val() == "") {
            e.preventDefault();
            notification.html("<span>" + newPostalCode.data("message-required") + "</span>");
            return false;
        }
        if (newCity.val() == "") {
            e.preventDefault();
            notification.html("<span>" + newCity.data("message-required") + "</span>");
            return false;
        }

        if (area_code.val() == "") {
            e.preventDefault();
            notification.html("<span>" + area_code.data("message-required") + "</span>");
            return false;
        }
    }
    if (e.isDefaultPrevented() === false) {
        notification.empty();
        loaderHolder.removeClass('loader-hidden');
        triggerBtn.addClass('loader-hidden');
    }
});

$("#newsletter-subscribe-form-page").submit(function(e) {
    var email = $(this).find("input[name=email]"),
        notification = $(this).find(".notification");

    if (email.val() == "") {
        notification.html("<span>" + email.data("message-required") + "</span>");
        e.preventDefault();
        return false;
    } else {
        if (!validateEmail(email.val())) {
            notification.html("<span>" + email.data("message-incorrect") + "</span>");
            e.preventDefault();
            return false;
        }
    }

    var captcha = grecaptcha.getResponse(captchaWidget);

    if (captcha.length == 0) {
        notification.html("<span>" + recaptchaHolder.data("message-required") + "</span>");
        e.preventDefault();
        return false;
    }

    $('.newsletter_page_button').hide();
    $('.newsletter_page_loading').show();
});

$("#newsletter-subscribe-form").submit(function(e) {
    var email = $(this).find("input[name=email]").val(),
        form = $(this),
        notification = $(this).find(".notification");

    e.preventDefault();

    $('.newsletter_popup_button_loading').hide();
    $('.newsletter_popup_loading').show();

    $.ajax({
        url: SITE_URL + "newsletter/ajax_subscribe",
        type: "post",
        data: {
            lang: LANG,
            email: email,
            recaptcha: grecaptcha.getResponse(captchaWidgetNewsletter)
        },
        dataType: "json",
        success: function(response) {
            grecaptcha.reset(captchaWidgetNewsletter);

            if (response.success) {
                form[0].reset();
            }

            notification.html("<p>" + response.message + "</p>");

            
            $('.newsletter_popup_button_loading').show();
            $('.newsletter_popup_loading').hide();
            window.location.replace(response.url)
        }
    });
});

$.ajax({
    url: SITE_URL + "util/get_global_components/" + LANG,
    type: "get",
    dataType: "json",
    success: function (data) {
        $("#n-footer-links2").html(data.footer_links);
        $("#b-footer-contact").html(data.footer_contact);
        $("#b-footer-about").html(data.footer_about);
        $("#b-header-email").html(data.header_email);
        $("#b-header-phone").html(data.header_phone);

        if ($("#n-categories").length > 0) {
            $("#n-categories").html(data.categories_sidebar);
        }
    },
    error: function () {
        modal.open();
        $modalMessage.html("<p>FATAL! Server error!</p>");
    }
});

$(".get-form").submit(function () {
    $(".get-form").find(":input").each(function () {
        if ($(this).val() == "") {
            $(this).attr("disabled", true);
        }
    });
});

$(".form-select").change(function () {
    $("#search-form").trigger("submit");
});

$(".load-more-link").click(function(e) {
    var hidden = $(this).parent().parent().find(".chunk.hidden");
    if (hidden.length) {
        e.preventDefault();

        hidden.first().removeClass("hidden");
        revalidateBLazy();
    }
    if (hidden.length - 1 == 0) {
        $(this).parent().empty();
    }
});

$("body").on("submit", ".add-to-cart-form", function(e) {
    if (!validateOptions($(this))) {
        modal.open();
        $modalMessage.html("<p>" + $(this).find("select[name^=options]").data("message-required") + "</p>");

        return false;
    }

    if (!validateVariable($(this))) {
        modal.open();
        $modalMessage.html("<p>" + $(this).find("select[name^=variable_products]").data("message-required") + "</p>");

        return false;
    }



    e.preventDefault();
    var imgtofly = $(this).closest("[data-product='holder']").find(".gc-display-display").eq(0);

    $.ajax({
        url: SITE_URL + "cart/add_to_cart",
        method: "post",
        data: $(".add-to-cart-form").serialize(),
        dataType: "json",
        async: false,
        success: function(data) {
            if (data.success) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                'event': 'addToCart'
                });

                $("#shop-cart").replaceWith(data.cart);

                if (typeof imgtofly.offset() === "undefined") {
                    modal.open();
                    $modalMessage.html("<p>Proizvod je dodat u korpu</p>");
                } else {
                    fly(imgtofly);
                }
            } else {
                modal.open();
                $modalMessage.html("<p>"+ data.message +"</p>");
            }
        },
        error: function() {
            console.error("FATAL! Server error!");
        }
    });
});

$("body").on("submit", ".add-voucher-to-cart-form", function(e) {
    e.preventDefault();
    var imgtofly = $(this).closest("[data-product='holder']").find(".gc-display-display").eq(0);

    $.ajax({
        url: SITE_URL + "cart/add_voucher_to_cart",
        method: "post",
        data: $(".add-voucher-to-cart-form").serialize(),
        dataType: "json",
        success: function(data) {
            if (data.success) {
                $("#shop-cart").replaceWith(data.cart);

                if (typeof imgtofly.offset() === "undefined") {
                    modal.open();
                    $modalMessage.html("<p>Vaučer je dodat u korpu</p>");
                } else {
                    fly(imgtofly);
                }
            } else {
                modal.open();
                $modalMessage.html("<p>"+ data.message +"</p>");
            }
        },
        error: function() {
            console.error("FATAL! Server error!");
        }
    });
});

$("#new_address_checkbox").click(function() {
    calculateShipping();
    refreshPaymentOptions();
});

$("#country").change(function(){
    $("#area_code").val('+' + $(this).find(':selected').data('phone_code'));
    var country_id = $(this).find(':selected').val();
    if (country_id == 244 || country_id == 15) {
        $.ajax({
            url: SITE_URL + "users/get_states",
            type: "post",
            async:false,
            data: {
                country_id: country_id
            },
            success: function (response) {
                var trHTML = '';
                $('.state').empty();
                trHTML += '<div class="select margin">';
                    trHTML += '<i class="fa fa-caret-down"></i>';
                    trHTML += '<select name="state">';
                    $.each(response.states, function (key,value) {
                        trHTML += 
                            '<option value="'+ value.name +'">'+ value.name +'</option>';    
                    });
                    trHTML += '</select>';
                trHTML += '</div>';
                $('.state').append(trHTML);
            },
            error: function () {
            }
        });
    }
    else {
        var trHTML = '';
        $('.state').empty();
        trHTML += '<input class="c-input" type="text" name="state">';
        $('.state').append(trHTML); 
    }
});

$("#new-country").change(function() {
    $("#new_area_code").val('+' + $(this).find(':selected').data('phone_code'));
    var country_id = $(this).find(':selected').val();
    if (country_id == 244 || country_id == 15) {
        $.ajax({
            url: SITE_URL + "users/get_states",
            type: "post",
            async:false,
            data: {
                country_id: country_id
            },
            success: function (response) {
                var trHTML = '';
                $('.state_row').empty();
                trHTML += '<div class="select margin">';
                    trHTML += '<i class="fa fa-caret-down"></i>';
                    trHTML += '<select name="new_state">';
                    $.each(response.states, function (key,value) {
                        trHTML += 
                            '<option value="'+ value.name +'">'+ value.name +'</option>';    
                    });
                    trHTML += '</select>';
                trHTML += '</div>';
                $('.state_row').append(trHTML);
            },
            error: function () {
            }
        });
    }
    else {
        var trHTML = '';
        $('.state').empty();
        trHTML += '<input class="c-input" type="text" name="new_state">';
        $('.state').append(trHTML); 
    }
    refreshPaymentOptions();
    calculateShipping();
});

$(".filter-submit").click(function() {
    $("#search-form").trigger("submit");
});

function refreshPaymentOptions() {
    var country = $("#country-id").val(),
        newCountry = $("#new-country").val(),
        flag = $("#new_address_checkbox").is(":checked");

    if (country != 193 && country != 29 && country != 151) {
        $(".payment_type_cod").hide();
    } else if ((country == 193 && flag && newCountry != 193) || (country == 29 && flag && newCountry != 29) || (country == 151 && flag && newCountry != 151)) {
        $(".payment_type_cod").hide();
        $("#card").click();
    } else {
        $(".payment_type_cod").show();
    }
}

function calculateShipping() {
    var country = $("#country-id").val();
    var eu_countries = ["16", "23", "35", "59", "62", "63", "64", "74", "80", "81", "88", "91", "104", "110", "113", "125", "131", "132", "140", "159", "180",
     "181", "185", "198", "199", "206", "219"];

    if ($("#new_address_checkbox").is(":checked")) {
        country = $("#new-country").val();
    }

    $.ajax({
        url: SITE_URL + "cart/recalculate_shipping",
        type: "post",
        data: {
            country: country
        },
        dataType: "json",
        success: function(data) {
            $("#shipping-price-holder").html(data.shipping_price);
            $("#total-price-holder").html(data.total_price);
        },
        error: function() {
            modal.open();
            $modalMessage.html("<p>FATAL! Server error!</p>");
        }
    });

    if (eu_countries.includes(country)) {
        $('.eu_terms').show();
    }
    else {
        $('.eu_terms').hide();
    }
}

function validateOptions(form) {
    var valid = true,
        options = form.find("select[name^=options]");

    options.each(function () {
        if ($(this).val() == "") {
            valid = false;
            return false;
        }
    });

    return valid;
}

function validateVariable(form) {
    var valid = true,
        variable_products = form.find("select[name^=variable_products]");

    if (variable_products) {
        variable_products.each(function () {
            if ($(this).val() == "") {
                valid = false;
                return false;
            }
        });
    }



    return valid;
}

// user form for sending voucher
$("body").on("submit", ".forward-voucher-form", function (e) {
    e.preventDefault();
    var email = $(this).find("input[name=email]");
    var voucher_id = $(this).find("input[name=voucher_id]");
    var notification = $(this).find(".notification");
    if (email.val() == "") {
        modal.open();
        $modalMessage.html("<p>" + $(this).find("input[name=email]").data("message-required") + "</p>");
        return false;
    } else {
        if (!validateEmail(email.val())) {
            modal.open();
            $modalMessage.html("<p>" + $(this).find("input[name=email]").data("message-incorrect") + "</p>");
            return false;
        }
    }
    $.ajax({
        url: SITE_URL + "users/send_voucher",
        type: "post",
        data: {
            email: email.val(),
            voucher_id: voucher_id.val(),
            lang: LANG
        },
        dataType: "json",
        success: function(data) {
            if (data.success) {
                location.reload();
            } else {
                modal.open();
                $modalMessage.html("<p>FATAL! Server error!</p>");
            }
        }
    });
});

$('.luxury-packaging').click(function (e) {

    //var paragraph = document.getElementById("luxury_packaging");
    var x = document.getElementById("luxury");
    //paragraph.textContent = "";
    if ($('input.luxury-packaging').is(':checked')) {
        luxury = 1;
        //paragraph.innerHTML += 'Extra stuff';
        x.style.display = "";
    } else {
        luxury = 0;
        x.style.display = "none";
    }
    $.ajax({
        url: SITE_URL + "cart/luxury_packaging/" + LANG,
        type: "post",
        data: {
            luxury: luxury
        },
        dataType: "json",
        success: function (data) {
            if (data.success) {
                window.location.replace(data.redirect_url);
            } else {
                notification.html("<span>" + data.message + "</span>");
            }
        }

    });

});

$('.radio-option-holder .shipping-off').click(function () {
    $('#shipping-price-holder').empty();
    var shipping = $('#shipping-price-holder').data('shipping');
    var total = $('#total-price-holder').data('total');
    var currency_str = $('#total-price-holder').data('currency');

    var new_price = total - shipping;

    $('.shipping-info').show();

    $(".payment_type_cod").show();

    $('#shipping-price-holder').append(parseFloat(0).toLocaleString('de-DE', {style: 'currency',currency: currency_str, minimumFractionDigits: 2, maximumFractionDigits: 2}));
    
    $('#total-price-holder').empty().append(parseFloat(new_price).toLocaleString('de-DE', {style: 'currency',currency: currency_str, minimumFractionDigits: 2, maximumFractionDigits: 2}));

});

$('.radio-option-holder .shipping-on').click(function () {
    var shipping = $('#shipping-price-holder').data('shipping');
    var total = $('#total-price-holder').data('total');
    var currency_str = $('#total-price-holder').data('currency');
    $('.shipping-info').hide();
    $('#shipping-price-holder').empty().append(parseFloat(shipping).toLocaleString('de-DE', {style: 'currency',currency: currency_str, minimumFractionDigits: 2, maximumFractionDigits: 2}));
    $('#total-price-holder').empty().append(parseFloat(total).toLocaleString('de-DE', {style: 'currency',currency: currency_str, minimumFractionDigits: 2, maximumFractionDigits: 2}));
    

    if (parseFloat(total) > 35000) {
        $(".payment_type_cod").hide();
        $("#cod").prop('checked', false);
        $(".payment_type_cod_label").removeClass('active');
    }
});


// add to cart action
// $("body").on("click", "a.discount_now", function (e) {
//     e.preventDefault();

//     var lang = $(this).data("lang");


//     $.ajax({
//         type: "post",
//         url: SITE_URL + "cart/send_discount_code",
//         data: {
//             lang: lang,
//         },
//         dataType: "json",
//         success: function (data) {
//             if (data.success) {

//                 $("#discount-div").replaceWith(data.cart);

//                 if (typeof imgtofly.offset() === "undefined") {
//                     modal.open();
//                     $modalMessage.html("<p>Proizvod je dodat u korpu</p>");
//                 } else {
//                     fly(imgtofly);
//                 }
//             } else {
//                 modal.open();
//                 $modalMessage.html("<p>"+ data.message +"</p>");
//             }
//         },
//         error: function (data) {
//             console.log(data);
//         }
//     });
// });
//let results_brands = $("#search-list-brands");

$(".select_variable_product").change(function () {
    
    var product_id = $(this).val();

    

    if (product_id && product_id != '') {
        
        $.ajax({
            url: SITE_URL + "products/get_view_product/" + LANG + "/" + product_id,
            type: "post",

            dataType: "json",
            success: function (data) {
                var option = $('option[value='+ product_id +']').data('option');
                console.log(option)

                $('.price_show').empty();
                $('.price_show').html(data.product.price);

                //$('.selected_product').empty();
                $('.selected_product').val(product_id);
                $('.option_value').val(option);
            }
            
    
        });

    }
});
